import { put, call, takeEvery } from 'typed-redux-saga';
import CustomerGateway from '~apis/customer';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import UtilFunctions from '~utils/functions';
import { MetalTypeEnum } from '~utils/enums';

export default function* watchGetPendingCollateralListing(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingCollateralListingAttempt', handleGetPendingCollateralListing, api);
}

function* handleGetPendingCollateralListing(api: CustomerGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            customerId,
            customerName,
            idNo,
            branchCode,
            status,
            dateFrom,
            dateTo,
            metalType,
        },
    } = reduxState.approval.pendingCollateralListing;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingCollateralListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getCollateralListing], {
        authToken,
        index,
        customerId: customerId || undefined,
        customerName: customerName || undefined,
        idNo: idNo || undefined,
        branchCode: branchCode || undefined,
        status: status || undefined,
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingCollateralListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingCollateralListingSuccess(response.data));
    }
}
